<template>
  <div class="message-box">
    <!-- 查询中 -->
    <div v-if="querying" class="message-title">
      <i class="el-icon-loading"></i>
      正在查询支付结果...
    </div>
    <!-- 未支付，等待用户确认 -->
    <template v-else>
      <div class="message-title">
        <i class="el-icon-question"></i>
        请确认微信支付是否已完成
      </div>
      <div class="message-button callback-buttons">
        <el-button type="primary" size="small" :loading="loading" @click="handleCompleted">已完成支付</el-button>
        <el-button size="small" @click="handleRepay">支付遇到问题，重新支付</el-button>
      </div>
    </template>
  </div>
</template>

<script>

export default {
  props: {
    payMethod: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      querying: true,
      loading: false
    }
  },
  methods: {
    /**
     * 查询支付结果，返回是否已支付（查询异常按未支付处理）
     */
    async queryResult() {
      try {
        await this.$store.dispatch('payResult/query', this.id)
      } catch (e) {
        return false
      }
      return this.$store.state.payResult.result === true
    },
    toSuccess() {
      this.$router.replace({
        name: 'pay-return',
        params: {
          payMethod: this.payMethod,
          id: this.id
        }
      })
    },
    async handleCompleted() {
      if (this.loading) {
        return
      }
      this.loading = true
      const paid = await this.queryResult()
      this.loading = false
      if (paid) {
        this.toSuccess()
      } else {
        this.$message.warning('暂未查询到支付结果，请确认支付完成后再试')
      }
    },
    handleRepay() {
      this.$router.replace({
        name: 'pay-pay',
        params: { id: this.id }
      })
    }
  },
  async mounted() {
    const paid = await this.queryResult()
    this.querying = false
    if (paid) {
      this.toSuccess()
    }
  }
}
</script>

<style scoped lang="less">
  .message-title {
    font-size: 1.2rem;
  }
  .callback-buttons {
    display: flex;
    flex-direction: column;
    align-items: center;
    .el-button {
      width: 60vw;
      margin: 0 0 2vh 0;
      padding: 1rem 0;
      font-size: 1rem;
    }
    .el-button + .el-button {
      margin-left: 0;
      background-color: #ffffff;
      color: #004da0;
      &:hover {
        background-color: #ffffff;
        color: #004da0;
      }
    }
  }
</style>
